module.exports = __webpack_public_path__ + "img/whats-app.45d61929.svg";